import wxContactImage from '../../../assets/images/wx_contact.jpg';
import { useState, useEffect } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [lastSubmitTime, setLastSubmitTime] = useState<number>(0);
  const [canSubmit, setCanSubmit] = useState<boolean>(true);
  const [countdown, setCountdown] = useState<number>(0);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 手机号验证函数
  const isValidPhone = (phone: string): boolean => {
    // 中国大陆手机号验证规则
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  // 倒计时效果
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0 && !canSubmit) {
      setCanSubmit(true);
    }
    return () => clearTimeout(timer);
  }, [countdown, canSubmit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (formData.name.length > 20) {
      setSubmitMessage('姓名最多只能输入20个字符');
      return;
    }

    if (!isValidPhone(formData.phone)) {
      setSubmitMessage('请输入正确的手机号码');
      return;
    }

    // 验证留言内容
    if (formData.message.length > 500) {
      setSubmitMessage('留言内容不能超过500字');
      return;
    }

    // 检查提交频率限制（1分钟）
    const now = Date.now();
    const timeSinceLastSubmit = now - lastSubmitTime;
    const oneMinute = 60 * 1000;

    if (!canSubmit && timeSinceLastSubmit < oneMinute) {
      setSubmitMessage(`请${countdown}秒后再次提交`);
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {


      // 使用JSON格式提交数据，而不是multipart/form-data
      const response = await fetch('http://www.sh-wanjiang.com/prod-api/official/sendEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)

      });

      // 解析响应数据
      const result = await response.json();

      // 判断返回对象的code是否为200
      if (result && result.code === 200) {
        // 记录提交时间并开始倒计时
        setLastSubmitTime(now);
        setCanSubmit(false);
        setCountdown(60);

        setSubmitMessage('提交成功！我们会尽快与您联系。');
        setFormData({
          name: '',
          company: '',
          phone: '',
          email: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitMessage(result?.message || '提交失败，请稍后重试。');
      }
    } catch (error) {
      setSubmitMessage('网络错误，请稍后重试。');
    }

    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="py-8 md:py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区：动态缩放，避免大屏突兀、小屏溢出 */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-[clamp(1.75rem,3.5vw,2.5rem)] font-bold text-gray-900 mb-6">
            联系我们
          </h2>
          <p className="text-[clamp(0.875rem,1.8vw,1.125rem)] text-gray-600 max-w-3xl mx-auto">
            欢迎与我们取得联系，我们将为您提供专业的水环境治理方案咨询服务
          </p>
        </div>

        {/* 联系内容区：左右分栏响应式，全元素同步缩放 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[clamp(2rem,4vw,3rem)]">
          {/* 左侧：联系信息 + 微信二维码 */}
          <div className="space-y-[clamp(1.5rem,3vw,2rem)]">
            {/* 联系方式列表 */}
            <div>
              <h3 className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold text-gray-900 mb-[clamp(1rem,2vw,1.5rem)]">
                联系方式
              </h3>
              <div className="space-y-[clamp(1rem,2vw,1.5rem)]">
                {/* 公司地址（修复笔误“上海是”→“上海市”） */}
                <div className="flex items-start space-x-[clamp(0.75rem,1.5vw,1rem)]">
                  {/* 图标容器：动态尺寸，保持圆形比例 */}
                  <div className="w-[clamp(2.5rem,5vw,3rem)] h-[clamp(2.5rem,5vw,3rem)] bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-blue-600 text-[clamp(1rem,2vw,1.25rem)]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-[clamp(0.875rem,1.5vw,1rem)]">
                      公司地址
                    </h4>
                    <p className="text-gray-600 text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                      上海市浦东新区秀浦路3188弄创研智造B10-13号
                    </p>
                  </div>
                </div>

                {/* 联系电话 */}
                <div className="flex items-start space-x-[clamp(0.75rem,1.5vw,1rem)]">
                  <div className="w-[clamp(2.5rem,5vw,3rem)] h-[clamp(2.5rem,5vw,3rem)] bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-blue-600 text-[clamp(1rem,2vw,1.25rem)]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-[clamp(0.875rem,1.5vw,1rem)]">
                      联系电话
                    </h4>
                    <p className="text-gray-600 text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                      021-60755700（工作日 8:00-17:00）
                    </p>
                  </div>
                </div>

                {/* 邮箱地址 */}
                <div className="flex items-start space-x-[clamp(0.75rem,1.5vw,1rem)]">
                  <div className="w-[clamp(2.5rem,5vw,3rem)] h-[clamp(2.5rem,5vw,3rem)] bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-blue-600 text-[clamp(1rem,2vw,1.25rem)]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-[clamp(0.875rem,1.5vw,1rem)]">
                      邮箱地址
                    </h4>
                    <p className="text-gray-600 text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                      wanjianghuanjing@163.com
                    </p>
                  </div>
                </div>

                {/* 微信公众号 */}
                <div className="flex items-start space-x-[clamp(0.75rem,1.5vw,1rem)]">
                  <div className="w-[clamp(2.5rem,5vw,3rem)] h-[clamp(2.5rem,5vw,3rem)] bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-blue-600 text-[clamp(1rem,2vw,1.25rem)]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-[clamp(0.875rem,1.5vw,1rem)]">
                      微信公众号
                    </h4>
                    <p className="text-gray-600 text-[clamp(0.8125rem,1.2vw,0.875rem)]">
                      万江环境（扫码关注获取更多资讯）
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 微信二维码卡片：二维码完整显示，不裁剪 */}
            <div className="bg-white p-[clamp(1rem,2vw,1.5rem)] rounded-2xl shadow-lg">
              <h4 className="text-[clamp(0.9375rem,1.8vw,1.125rem)] font-semibold text-gray-900 mb-[clamp(0.75rem,1.5vw,1rem)] text-center">
                关注微信公众号
              </h4>
              <div className="flex justify-center">
                <div className="text-center">
                  <img
                    src={wxContactImage}
                    alt="微信公众号二维码"
                    className="w-[clamp(80px,20vw,120px)] h-[clamp(80px,20vw,120px)] object-contain rounded-lg" // 宽高一致，完整显示
                  />
                  <p className="text-[clamp(0.75rem,1.2vw,0.8125rem)] text-gray-500 mt-[clamp(0.5rem,1vw,0.75rem)]">
                    微信扫码关注
                  </p>
                </div>
              </div>
              <p className="text-center text-gray-600 mt-[clamp(0.75rem,1.5vw,1rem)] text-[clamp(0.75rem,1.2vw,0.8125rem)]">
                扫描二维码关注我们的公众号，获取最新环保资讯和解决方案
              </p>
            </div>
          </div>

          {/* 右侧：联系表单 */}
          <div className="bg-white p-[clamp(1rem,2vw,1.5rem)] rounded-2xl shadow-lg">
            <h3 className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold text-gray-900 mb-[clamp(0.75rem,1.5vw,1rem)]">
              在线咨询
            </h3>

            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-[clamp(0.75rem,1.5vw,1rem)]">
              {/* 姓名和公司（两列布局） */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[clamp(0.5rem,1vw,0.75rem)]">
                {/* 姓名输入框 */}
                <div>
                  <label className="block text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium text-gray-700 mb-[clamp(0.25rem,0.5vw,0.5rem)]">
                    姓名 *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-[clamp(0.75rem,1.5vw,1rem)] py-[clamp(0.5rem,1vw,0.75rem)] border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-[clamp(0.75rem,1.2vw,0.8125rem)]"
                    placeholder="请输入您的姓名"
                  />
                </div>
                {/* 公司名称输入框 */}
                <div>
                  <label className="block text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium text-gray-700 mb-[clamp(0.25rem,0.5vw,0.5rem)]">
                    公司名称
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="w-full px-[clamp(0.75rem,1.5vw,1rem)] py-[clamp(0.5rem,1vw,0.75rem)] border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-[clamp(0.75rem,1.2vw,0.8125rem)]"
                    placeholder="请输入公司名称"
                  />
                </div>
              </div>

              {/* 电话和邮箱（两列布局） */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[clamp(0.5rem,1vw,0.75rem)]">
                {/* 联系电话输入框 */}
                <div>
                  <label className="block text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium text-gray-700 mb-[clamp(0.25rem,0.5vw,0.5rem)]">
                    联系电话 *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-[clamp(0.75rem,1.5vw,1rem)] py-[clamp(0.5rem,1vw,0.75rem)] border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-[clamp(0.75rem,1.2vw,0.8125rem)]"
                    placeholder="请输入联系电话"
                  />
                </div>
                {/* 邮箱地址输入框 */}
                <div>
                  <label className="block text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium text-gray-700 mb-[clamp(0.25rem,0.5vw,0.5rem)]">
                    邮箱地址
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-[clamp(0.75rem,1.5vw,1rem)] py-[clamp(0.5rem,1vw,0.75rem)] border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-[clamp(0.75rem,1.2vw,0.8125rem)]"
                    placeholder="请输入邮箱地址"
                  />
                </div>
              </div>

              {/* 服务选择下拉框 */}
              <div>
                <label className="block text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium text-gray-700 mb-[clamp(0.25rem,0.5vw,0.5rem)]">
                  感兴趣的服务
                </label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleInputChange}
                  className="w-full px-[clamp(0.75rem,1.5vw,1rem)] py-[clamp(0.5rem,1vw,0.75rem)] border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-[clamp(0.75rem,1.2vw,0.8125rem)] pr-8 appearance-none bg-white"
                >
                  <option value="">请选择服务类型</option>
                  <option value="智慧城市与管网解决方案">智慧城市与管网解决方案</option>
                  <option value="河湖生态与水环境修复">河湖生态与水环境修复</option>
                  <option value="智慧环境监测设备及软件服务">智慧环境监测设备及软件服务</option>
                  <option value="环保综合服务">环保综合服务</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              {/* 详细需求文本域 */}
              <div>
                <label className="block text-[clamp(0.75rem,1.2vw,0.8125rem)] font-medium text-gray-700 mb-[clamp(0.25rem,0.5vw,0.5rem)]">
                  详细需求 *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-[clamp(0.75rem,1.5vw,1rem)] py-[clamp(0.5rem,1vw,0.75rem)] border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-[clamp(0.75rem,1.2vw,0.8125rem)] resize-none"
                  placeholder="请详细描述您的水环境治理需求或问题..."
                ></textarea>
                <div className="text-right mt-1">
                  <span className="text-[clamp(0.625rem,1vw,0.75rem)] text-gray-500">
                    {formData.message.length}/500
                  </span>
                </div>
              </div>

              {/* 提交按钮 */}
              <button
                type="submit"
                disabled={isSubmitting || !canSubmit}
                className="w-full bg-blue-600 text-white py-[clamp(0.75rem,1.5vw,1rem)] px-[clamp(1rem,2vw,1.5rem)] rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap text-[clamp(0.8125rem,1.2vw,0.875rem)]"
              >
                {isSubmitting ? '提交中...' : (!canSubmit ? `请${countdown}秒后再次提交` : '提交咨询')}
              </button>

              {/* 提交结果提示 */}
              {submitMessage && (
                <div className={`text-center p-[clamp(0.5rem,1vw,0.75rem)] rounded-lg ${submitMessage.includes('成功') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                  } text-[clamp(0.75rem,1.2vw,0.8125rem)]`}>
                  {submitMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
